import React, { useEffect, useState } from "react";
import { Table, OverlayTrigger, Tooltip } from "react-bootstrap";

const truncateText = (text: string, maxLength: number) => {
  if (text?.length > maxLength) {
    return text.slice(0, maxLength) + "...";
  }
  return text;
};

const DoctorDetailsTable = ({
  onDoctorSelect,
  QMEDoctorOptions = [],
}: {
  onDoctorSelect: (doctor: any[]) => void;
  QMEDoctorOptions: any[];
}) => {
  const [selectedDoctor, setSelectedDoctor] = useState<any>(null);

  useEffect(() => {
    if (QMEDoctorOptions?.length > 0 && !selectedDoctor) {
      setSelectedDoctor(QMEDoctorOptions[0]);
      onDoctorSelect(QMEDoctorOptions[0]);
    }
  }, [QMEDoctorOptions, selectedDoctor, onDoctorSelect]);

  const handleRadioChange = (doctor: any) => {
    setSelectedDoctor(doctor);
    onDoctorSelect(doctor);
  };

  return (
    <div className="table-responsive border-0 mb-2 doctor-detail">
      <Table responsive>
        <thead>
          <tr>
            <th style={{ width: "10%" }}></th>
            <th style={{ width: "50%", cursor: "default" }}>Doctor & Type</th>
            <th style={{ width: "40%", cursor: "default" }}>
              Appointment Count
            </th>
          </tr>
        </thead>
        <tbody>
          {QMEDoctorOptions?.map((doc) => {
            const truncatedName = truncateText(doc.contactFullName, 30);
            const truncatedType = truncateText(doc.party, 30);

            const isTruncated =
              doc.contactFullName?.length > 30 || doc.party?.length > 30;

            return (
              <tr
                key={doc.id}
                className={`cursor-pointer ${
                  selectedDoctor?.id === doc.id ? "rowSelectedDoctorCheck" : ""
                }`}
                onClick={() => handleRadioChange(doc)}
              >
                <td className="text-center rowSelectedDoctorCheck1">
                  <input
                    type="radio"
                    name="doctorSelect"
                    checked={selectedDoctor?.id === doc.id}
                    onChange={() => handleRadioChange(doc)}
                  />
                </td>
                <td className=" rowSelectedDoctorCheck1">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      isTruncated ? (
                        <Tooltip id={`tooltip-${doc.id}`}>
                          <div>
                            <strong>Doctor:</strong> {doc.contactFullName}
                          </div>
                          <div>
                            <strong>Type:</strong> {doc.party}
                          </div>
                        </Tooltip>
                      ) : (
                        <></>
                      )
                    }
                  >
                    <div>
                      <div style={{ cursor: "default" }}>{truncatedName}</div>
                      <div className="fw-bold" style={{ cursor: "default" }}>
                        {truncatedType}
                      </div>
                    </div>
                  </OverlayTrigger>
                </td>
                <td
                  className="text-center rowSelectedDoctorCheck1"
                  style={{ cursor: "default" }}
                >
                  {doc?.totalAppointmentsCount || ""}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default DoctorDetailsTable;
